import { useMemo } from "react";
import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import { useGetBreakpoints } from "../../../responsiveTools/breakpoints";

export const useGetColumns = (hanldeOpenObservacionModal) => {

    const { isMobile } = useGetBreakpoints();

    const initialColumns = [
        {
            headerName: "",
            field: "action",
            flex: 1.5,
            width: 40,
            minWidth: 40,
            maxWidth: 40,
            sortable: false,
            noPadding: true,
            align: "center",
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <IconButton onClick={() => hanldeOpenObservacionModal(row?.idNotificacion, row?.observacion)}>
                        <VisibilityIcon />
                    </IconButton>
                );
            }
        },
        {
            flex: 60,
            width: 60,
            field: 'idNotificacion',
            headerName: '#'
        },
        {
            flex: 80,
            width: 80,
            field: 'fechaNotificacion',
            headerName: 'F. Notif',
            type: 'date'
        },
        {
            flex: 120,
            width: 120,
            field: 'emisor',
            headerName: 'Emisor'
        },
        {
            flex: 120,
            width: 120,
            field: 'receptor',
            headerName: 'Receptor',
        },
        {
            flex: 95,
            width: 95,
            field: 'tipo',
            headerName: 'T. profesional',
        },
    ];

    const columns = useMemo(() => {
        const processedColumns = initialColumns.map(column =>
            isMobile ? { ...column, flex: undefined } : column
        );
        return generateColumnsDefaultConfiguration(processedColumns, isMobile);
    }, [initialColumns, isMobile]);

    return columns;
}